export default __webpack_public_path__ + "static/media/icn-message-success.9e8d3db0.svg";